/**
 * 数字处理mixin
 */
import { Big } from 'big.js'
export default {
  methods: {
    /**
     * @description 处理数字输入
     * @param val 输入值
     * @param field 输入值对应的字段
     * @param digit 保留的小数位
     */
    handleInput(val, field, digit) {
      val = val.replace(
        new RegExp(`^\\D*(\\d*(?:\\.\\d{0,${digit}})?).*$`, 'g'),
        '$1'
      )

      if (val === '') {
        this[field] = val
        return
      }
      if (val.includes('.')) {
        const [_int, _digit] = val.split('.')
        val = `${Big(_int).toFixed()}.${_digit || ''}`
      } else {
        val = Big(val).toFixed()
      }

      this[field] = val
    },
    /**
     * @description 截取指定小数位数字
     */
    truncateDigit(str, digit = 2) {
      return str.replace(
        new RegExp(`^(\\d+(\\.\\d{1,${digit}})?)\\d*$`, 'g'),
        '$1'
      )
    },
  },
}
